import * as React from 'react';
import { IDatasheetResultElement } from '../types/datasheet-element';
import { IDatasheetComponentDto } from '@common/dto/datasheet/datasheet-component';
import { DatasheetFieldComponentGetDto } from '@common/dto/datasheet/field-component/get-dto';
import { DatasheetFieldComponentHeadingPosition } from '@common/dto/datasheet/field-component/heading-position';

export type DatasheetElementControllerProps<T extends IDatasheetComponentDto = IDatasheetComponentDto> = IDatasheetResultElement<T>;
export type DatasheetElementControllerParams = {
  headingSizeDependencies: Array<any>;
};

export const getCommonFieldBasedElementParams = (props: DatasheetElementControllerProps<DatasheetFieldComponentGetDto>) => {
  const { datasheetElement } = props;
  const headingPosition = datasheetElement.original.headpos;

  const headingPlacedHorizontally = [
    DatasheetFieldComponentHeadingPosition.left,
    DatasheetFieldComponentHeadingPosition.right,
  ].includes(headingPosition);
  
  return {
    headingSizeDependencies: [
      datasheetElement.original.headtext,
      datasheetElement.original.headfontsize,
      datasheetElement.original.headfont,
      datasheetElement.original.headdisplay,
      datasheetElement.original.headpos,
    ],
    headingPlacedHorizontally,
    headingPosition,
  };
};

export const useDatasheetElementController = <T extends IDatasheetComponentDto = IDatasheetComponentDto>(
  props: DatasheetElementControllerProps<T>, 
  params?: DatasheetElementControllerParams
) => {
  const [headingSize, setHeadingSize] = React.useState<{ width: number; height: number }>({ width: 0, height: 0 });

  const handleHeadingSizeChange = React.useCallback((size: { width: number; height: number }) => {
    setHeadingSize(size);
  }, []);

  const headingReference = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (headingReference.current) {
      handleHeadingSizeChange({
        width: headingReference.current.offsetWidth,
        height: headingReference.current.offsetHeight,
      });
    }
  }, params?.headingSizeDependencies);

  return {
    headingReference,
    handleHeadingSizeChange,
    headingSize,
  };
};